import localScaleManager from "../../../../helpers/LocalScaleManager";
import Card from "./card";
import { tweenConfigs } from "../../../../helpers/tweensConfigs";
import { WebSocketManager } from "../../../../helpers/webSocketManager";

export class Cards {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param rowIndex {number}
   */
  constructor(scene, table, rowIndex) {
    this.scene = scene;
    this.table = table;
    this.rowIndex = rowIndex;

    this.cardsList = this._initializeCards(scene, table, rowIndex);
    this.cardsXList = [];
    this.cardsScaleX = 0;
    this.cardsScaleY = 0;
    this.cardZoom = 0;

    this.areFlopCardsShown = false;
    this.isTurnCardShown = false;
    this.isRiverCardShown = false;

    this.rabbit = this._initializeRabbit(scene);
    this.rabbitClicked = false;
    // this.cardsOverlay = this.scene.add.group({
    //     key: 'card-overlay',
    //     repeat: 4
    // });
    this.idleState();

    this.tweenDelay = 0;
    this.tweenDelayCalculated = false;
  }

  _initializeCards(scene, table, rowIndex) {
    const cardsGroup = scene.add.group();
    for (let i = 0; i < 5; i++) {
      cardsGroup.add(new Card(scene, table, rowIndex));
    }
    table.poolArray.push(cardsGroup);
    return cardsGroup;
  }

  _initializeRabbit(scene) {
    const rabbit = scene.add
      .sprite(0, 0, scene.atlasTexture, "rabbit-1")
      .setOrigin(0.5)
      .setVisible(false)
      .setInteractive({ cursor: "pointer" });

    rabbit.on("pointerdown", () => (this.rabbitClicked = true));
    rabbit.on("pointerout", () => (this.rabbitClicked = false));
    rabbit.on("pointerup", () => this._handleRabbitClick());

    rabbit.play("rabbit-blink");
    this.table.poolArray.push(rabbit);
    return rabbit;
  }

  _handleRabbitClick() {
    if (!this.rabbitClicked) return;

    this.rabbitClicked = false;
    this.rabbit.disableInteractive();

    WebSocketManager.emitEvent(
      { tableId: this.table.tableInfo.id },
      "poker.client-push.rabbit-show"
    )
      .then(() => this.hideRabbit())
      .finally(() => this.rabbit.setInteractive());
  }

  hideRabbit() {
    if (this.rabbit.anims?.isPlaying) {
      this.rabbit.anims.pause();
    }
    if (this.rabbit.visible) this.rabbit.setVisible(false);
  }

  visibilityControls(visibility) {
    if (this.cardsList.visible !== visibility) {
      this.cardsList.setVisible(visibility);
    }
    if (!visibility && this.rabbit.anims?.isPlaying) {
      this.rabbit.anims.pause();
    }
    if (this.rabbit.visible !== visibility) this.rabbit.setVisible(visibility);
    // Phaser.Actions.SetVisible([this.cardsList.getChildren()], visibility);
  }

  idleState() {
    this.visibilityControls(false);

    this.cardsList.children.iterate((card) => {
      if (card.beforeWinY && card.beforeWinY !== card.y) {
        card.y = card.beforeWinY;
      }
      card.hideCardOverlay();
      if (card.upsideDown.visible) card.upsideDown.setVisible(false);
    }, this);

    this.areFlopCardsShown = false;
    this.isTurnCardShown = false;
    this.isRiverCardShown = false;
  }
  /**
   * @param cards
   * @param setDelay {boolean} when we need to stack the chips of players first, we should set a delay for cards' tween in order to show cards after stacking chips.
   * @returns {Promise<unknown>}
   */
  showFlopCards(cards, setDelay, showByRabbit) {
    if (!cards || cards.length < 3) return;

    return new Promise((resolve) => {
      for (let i = 0; i < 3; i++) {
        const card = this.cardsList.getChildren()[i];
        card.updateTexture(cards[i].code);
        card.setX(this.cardsXList[0]);
        if (i === 0) {
          card.scaleX = 0;
        }
      }
      const [flopCard1, flopCard2, flopCard3] = this.cardsList.getChildren();

      if (!flopCard1.visible) flopCard1.setVisible(true);

      if (this.cardsScaleX) {
        if (setDelay) this.setTweenDelay();
        else this.tweenDelay = 0;

        this.areFlopCardsShown = true;

        if (this.scene.tweenEnable && !this.table.firstGameState) {
          const frameName = showByRabbit ? "rabbit-1" : "back-card-red";
          [flopCard1, flopCard2, flopCard3].forEach((card) => {
            if (card.upsideDown.frame.name !== frameName)
              card.upsideDown.setFrame(frameName);
          });

          this.scene.tweens.add({
            targets: flopCard1.upsideDown,
            scaleX: 0,
            scaleY: this.cardZoom,
            ease: tweenConfigs.flopCards.first.ease,
            duration: tweenConfigs.flopCards.first.duration / 2,
            delay: this.tweenDelay,
            onStart: () => {
              if (!flopCard1.upsideDown.visible)
                flopCard1.upsideDown.setVisible(true);
            },
            onComplete: () => {
              if (flopCard1.upsideDown.visible)
                flopCard1.upsideDown.setVisible(false);
              flopCard1.upsideDown.scaleX = this.cardsScaleX;
              flopCard1.upsideDown.scaleY = this.cardsScaleY;
            },
          });
          flopCard1.scaleY = this.cardZoom;
          this.scene.tweens.add({
            targets: flopCard1,
            scaleX: this.cardsScaleX,
            scaleY: this.cardsScaleY,
            ease: tweenConfigs.flopCards.first.ease,
            duration: tweenConfigs.flopCards.first.duration / 2,
            delay: this.tweenDelay + tweenConfigs.flopCards.first.duration / 2,
            onComplete: () => {
              flopCard1.scaleX = this.cardsScaleX;
              flopCard1.scaleY = this.cardsScaleY;
            },
          });
          this.scene.tweens.add({
            targets: flopCard2,
            x: this.cardsXList[1],
            ease: "Linear",
            delay: this.tweenDelay + 200 + 200,
            duration: 400,
            onStart: () => {
              this.table.sounds.play("flop");
              if (!flopCard2.visible) flopCard2.setVisible(true);
            },
            onComplete: () => {
              flopCard2.setX(this.cardsXList[1]);
            },
          });
          this.scene.tweens.add({
            targets: flopCard3,
            x: this.cardsXList[2],
            ease: "Linear",
            delay: this.tweenDelay + 200 + 200,
            duration: 400,
            onStart: () => {
              if (!flopCard3.visible) flopCard3.setVisible(true);
            },
            onComplete: () => {
              flopCard3.setX(this.cardsXList[2]);
              resolve();
            },
          });
        } else {
          if (!flopCard2.visible) flopCard2.setVisible(true);
          if (!flopCard3.visible) flopCard3.setVisible(true);
          flopCard1.scaleX = this.cardsScaleX;
          flopCard1.scaleY = this.cardsScaleY;
          flopCard2.setX(this.cardsXList[1]);
          flopCard3.setX(this.cardsXList[2]);
          resolve();
        }
      } else {
        resolve();
      }
    });
  }

  showTurnCard(cards, showByRabbit) {
    if (!cards || !cards[3]) return;
    return new Promise((resolve) => {
      let turnCard = this.cardsList.getChildren()[3];
      turnCard.updateTexture(cards[3].code);
      turnCard.scaleX = 0;
      if (!turnCard.visible) turnCard.setVisible(true);
      this.isTurnCardShown = true;
      this.setTweenDelay();
      if (this.scene.tweenEnable && !this.table.firstGameState) {
        // turnCard.upsideDown.setVisible(true);
        if (showByRabbit) {
          if (turnCard.upsideDown.frame.name !== "rabbit-1")
            turnCard.upsideDown.setFrame("rabbit-1");
        } else {
          if (turnCard.upsideDown.frame.name !== "back-card-red")
            turnCard.upsideDown.setFrame("back-card-red");
        }
        this.scene.tweens.add({
          targets: turnCard.upsideDown,
          scaleX: 0,
          scaleY: this.cardZoom,
          ease: tweenConfigs.flopCards.first.ease,
          duration: tweenConfigs.flopCards.first.duration / 2,
          onStart: () => {
            if (!turnCard.upsideDown.visible)
              turnCard.upsideDown.setVisible(true);
          },
          onComplete: () => {
            if (turnCard.upsideDown.visible)
              turnCard.upsideDown.setVisible(false);
            turnCard.upsideDown.scaleX = this.cardsScaleX;
            turnCard.upsideDown.scaleY = this.cardsScaleY;
          },
        });
        turnCard.scaleY = this.cardZoom;
        this.scene.tweens.add({
          targets: turnCard,
          scaleX: this.cardsScaleX,
          scaleY: this.cardsScaleY,
          ease: tweenConfigs.flopCards.first.ease,
          duration: tweenConfigs.flopCards.first.duration / 2,
          delay: tweenConfigs.flopCards.first.duration / 2,
          onStart: () => {
            this.table.sounds.play("turn-river");
          },
          onComplete: () => {
            turnCard.scaleX = this.cardsScaleX;
            turnCard.scaleY = this.cardsScaleY;
            resolve();
          },
        });
      } else {
        turnCard.scaleX = this.cardsScaleX;
        turnCard.scaleY = this.cardsScaleY;
        resolve();
      }
    });
  }
  showRiverCard(cards, showByRabbit) {
    if (!cards || !cards[4]) return;
    return new Promise((resolve) => {
      let riverCard = this.cardsList.getChildren()[4];
      riverCard.updateTexture(cards[4].code);
      riverCard.scaleX = 0;
      if (!riverCard.visible) riverCard.setVisible(true);
      this.isRiverCardShown = true;
      this.setTweenDelay();
      if (this.scene.tweenEnable && !this.table.firstGameState) {
        if (showByRabbit) {
          if (riverCard.upsideDown.frame.name !== "rabbit-1")
            riverCard.upsideDown.setFrame("rabbit-1");
        } else {
          if (riverCard.upsideDown.frame.name !== "back-card-red")
            riverCard.upsideDown.setFrame("back-card-red");
        }
        this.scene.tweens.add({
          targets: riverCard.upsideDown,
          scaleX: 0,
          scaleY: this.cardZoom,
          ease: tweenConfigs.flopCards.first.ease,
          duration: tweenConfigs.flopCards.first.duration / 2,
          onStart: () => {
            if (!riverCard.upsideDown.visible)
              riverCard.upsideDown.setVisible(true);
          },
          onComplete: () => {
            if (riverCard.upsideDown.visible)
              riverCard.upsideDown.setVisible(false);
            riverCard.upsideDown.scaleX = this.cardsScaleX;
            riverCard.upsideDown.scaleY = this.cardsScaleY;
          },
        });
        riverCard.scaleY = this.cardZoom;
        this.scene.tweens.add({
          targets: riverCard,
          scaleX: this.cardsScaleX,
          scaleY: this.cardsScaleY,
          ease: tweenConfigs.flopCards.first.ease,
          duration: tweenConfigs.flopCards.first.duration / 2,
          delay: tweenConfigs.flopCards.first.duration / 2,
          onStart: () => {
            this.table.sounds.play("turn-river");
          },
          onComplete: () => {
            riverCard.scaleX = this.cardsScaleX;
            riverCard.scaleY = this.cardsScaleY;
            resolve();
          },
        });
      } else {
        riverCard.scaleX = this.cardsScaleX;
        riverCard.scaleY = this.cardsScaleY;
        resolve();
      }
    });
  }
  setTweenDelay() {
    if (!this.tweenDelayCalculated) {
      const playerBet = this.table.playerSeats[0].playerBet;
      this.tweenDelay =
        playerBet.stackChipsTweenDuration +
        playerBet.stackChipsTweenDelay +
        100;
      this.tweenDelayCalculated = true;
    }
  }
  // handleVisibilityChange(hidden) {
  //   let activeTweens;
  //   if (hidden) {
  //     /* agar game hidden shod va active tween dashtim bayad hame ra foran b payan bbarim
  //      * ba tavajoh b inke agr tweeni k montazer etmam delay ast ra seek konim onStart on tween ejra nemishavad
  //      */
  //     activeTweens = this.scene.tweens.getTweensOf(
  //       this.cardsList.getChildren()
  //     );
  //     activeTweens.forEach((tween) => {
  //       tween.targets.forEach((t) => t.setVisible(true));
  //       tween.seek(1);
  //     });
  //   }
  // }
  getFlopCards() {
    return [
      this.cardsList.getChildren()[0],
      this.cardsList.getChildren()[1],
      this.cardsList.getChildren()[2],
    ];
  }
  getTurnCard() {
    return this.cardsList.getChildren()[3];
  }
  getRiverCard() {
    return this.cardsList.getChildren()[4];
  }
  showRabbitCard() {
    if (this.areFlopCardsShown) {
      if (this.isTurnCardShown) {
        if (this.isRiverCardShown) return;
        else {
          this.rabbit.setPosition(this.getRiverCard().x, this.getRiverCard().y);
        }
      } else {
        this.rabbit.setPosition(this.getTurnCard().x, this.getTurnCard().y);
      }
    } else {
      this.rabbit.setPosition(
        this.getFlopCards()[0].x,
        this.getFlopCards()[0].y
      );
    }
    if (this.scene.tweenEnable) {
      if (this.rabbit.anims && this.rabbit.anims.isPaused) {
        this.rabbit.anims.resume();
      }
    }
    if (!this.rabbit.visible) this.rabbit.setVisible(true);
  }
  showCardsByRabbit(gameState) {
    if (gameState.rabbitCardsCount === 3) {
      if (!this.areFlopCardsShown) {
        this.showFlopCards(gameState.tablesCards, false, true);
      }
    } else if (gameState.rabbitCardsCount === 2) {
      if (!this.isTurnCardShown) {
        this.showTurnCard(gameState.tablesCards, true);
      }
      if (!this.isRiverCardShown) {
        this.showRiverCard(gameState.tablesCards, true);
      }
    } else if (gameState.rabbitCardsCount === 1) {
      if (!this.isRiverCardShown) {
        this.showRiverCard(gameState.tablesCards, true);
      }
    }
  }
  /***
   *
   * @param width {number} width of table
   * @param height {number} height of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  positionControls(width, height, initX, initY) {
    this.cardsXList = [];

    const cardSize = width / 6;
    let cardWidth = 0;

    const cardScale = localScaleManager.scaleSprite(
      this.cardsList.getChildren()[0],
      cardSize,
      cardSize,
      0,
      1,
      true
    );

    localScaleManager.scaleSpriteTo(this.rabbit, cardScale);

    this.cardsList.children.iterate((card, i) => {
      localScaleManager.scaleSpriteTo(card, cardScale);
      card.scaleControls(cardSize);
      // localScaleManager.scaleSpriteTo(this.cardsOverlay.getChildren()[i], cardScale);
      if (i === 0) {
        cardWidth = card.displayWidth * 0.9;
        this.cardsScaleX = card.scaleX;
        this.cardsScaleY = card.scaleY;
        this.cardZoom = this.cardsScaleY * 1.3;
      }
      card.setPosition(
        initX + (width - cardWidth * 5) / 2 + i * cardWidth + cardWidth * 0.6,
        initY + height * 0.45 + this.rowIndex * height * 0.045
      );
      card.beforeWinY = card.y;
      card.positionControls();
      // this.cardsOverlay.getChildren()[i].setPosition(
      //     initX + (width - cardWidth * 5) / 2 + i * cardWidth + cardWidth / 2 ,
      //     initY + height / 2.75 + this.rowIndex * height / 20);
      this.cardsXList.push(this.cardsList.getChildren()[i].x);
    }, this);
  }
  /***
   *
   * @param width {number} width of table
   * @param height {number} height of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  reposition(width, height, initX, initY) {
    this.cardsXList = [];
    let cardWidth = 0;
    this.cardsList.children.iterate((card, i) => {
      if (i === 0) {
        cardWidth = card.displayWidth * 0.9;
      }
      card.setPosition(
        initX + (width - cardWidth * 5) / 2 + i * cardWidth + cardWidth * 0.6,
        initY + height * 0.45 + this.rowIndex * height * 0.045
      );
      card.beforeWinY = card.y;
      card.reposition();
      this.cardsXList.push(this.cardsList.getChildren()[i].x);
    }, this);
  }
  remove() {
    this.cardsList.destroy(true);
  }
}
